import { TableHead, SearchData } from "../../../../common/dataClass/Default"

class LogisticsTableHead extends TableHead{
  constructor(name, prop, width, obj) {
    super(name, prop, width, obj)
  }
}

class LogisticsSearchData extends SearchData{
  constructor() {
    super()
    /**创建日期 */
    this.date = ''
    /**单号 */
    this.orderNum = ''
  }
}

class LogisticsNewMoodule{
  /**物流计划表头 */
  static NEWPLANTABLEHEAD(){
    let arr = [
      new LogisticsTableHead('发补货计划单号<br>(FBA发补货计划单号)', 'img', '150'),
      new LogisticsTableHead('发补货计划单<br>创建日期', 'img', '100'),
      new LogisticsTableHead('计划出货日期', 'getNetProfitOfGoodsByTable', '100'),
      new LogisticsTableHead('总箱数', 'img', '80'),
      new LogisticsTableHead('总重量<br>(kg)', 'getNetProfitOfGoodsByTable', '80'),
      new LogisticsTableHead('总体积<br>(M³)', 'img', '80'),
      new LogisticsTableHead('目的国', 'getNetProfitOfGoodsByTable', '100'),
      new LogisticsTableHead('亚马逊<br>仓库代码', 'stockPrice', '100'),
      new LogisticsTableHead('货物所在仓库<br>(仓库ID)', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('头程物流方式<br>头程物流渠道', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('起运仓城市', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('全程物流时效<br>(天数)', 'stockPrice', '200'),
      new LogisticsTableHead('是否包含<br>进口关税', 'getSavePriceByTable', '100'),
      new LogisticsTableHead('含双清物流价格(¥)<br>(Door To Door)', 'disposalNum', '200'),
      new LogisticsTableHead('装箱详细', 'getCostSummaryByTable', '100'),
      new LogisticsTableHead('备货状态<br>(仓库分类)', 'disposalNum', '180'),
      new LogisticsTableHead('物流价格<br>更新日期', 'disposalNum', '150'),
      new LogisticsTableHead('物流报价', 'getCostSummaryByTable', '100'),
    ]
    return arr
  }
  /**待完成物流单表头 */
  static NEWTOBETABLEHEAD(){
    let arr = [
      new LogisticsTableHead('发货单号<br>(包含FBA发补货计划单号数量)', 'img', '150'),
      new LogisticsTableHead('创建日期', 'img', '100'),
      new LogisticsTableHead('总箱数', 'img', '80'),
      new LogisticsTableHead('总重量<br>(kg)', 'getNetProfitOfGoodsByTable', '80'),
      new LogisticsTableHead('总体积<br>(M³)', 'img', '80'),
      new LogisticsTableHead('货物起运所在地', 'getNetProfitOfGoodsByTable', '100'),
      new LogisticsTableHead('发运目的国地址<br>(仓库代码)', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('头程物流方式<br>头程物流渠道', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('全程物流时效<br>(天数)', 'stockPrice', '200'),
      new LogisticsTableHead('是否包含<br>进口关税', 'getSavePriceByTable', '100'),
      new LogisticsTableHead('含双清物流价格(¥)<br>(Door To Door)', 'disposalNum', '200'),
      new LogisticsTableHead('含单节省运费<br>(¥)', 'getNetProfitOfGoodsByTable', '100'),
      new LogisticsTableHead('物流报价<br>更新日期', 'disposalNum', '150'),
      new LogisticsTableHead('装箱详细', 'getCostSummaryByTable', '100'),
      new LogisticsTableHead('操作', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('物流预订', 'getCostSummaryByTable', '100'),
    ]
    return arr
  }
  /**未支付物流单表头 */
  static NEWUNPAIDTABLEHEAD(){
    let arr = [
      new LogisticsTableHead('选择', 'check', '40'),
      new LogisticsTableHead('发货单号<br>(含发补货计划单数量)', 'img', '150'),
      new LogisticsTableHead('创建日期', 'img', '100'),
      new LogisticsTableHead('总箱数', 'img', '80'),
      new LogisticsTableHead('总重量<br>(kg)', 'getNetProfitOfGoodsByTable', '80'),
      new LogisticsTableHead('总体积<br>(M³)', 'img', '80'),
      new LogisticsTableHead('货物起运所在地', 'getNetProfitOfGoodsByTable', '100'),
      new LogisticsTableHead('发运目的国地址<br>(仓库代码)', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('头程物流方式<br>头程物流渠道', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('全程物流时效<br>(天数)', 'stockPrice', '200'),
      new LogisticsTableHead('是否包含<br>进口关税', 'getSavePriceByTable', '100'),
      new LogisticsTableHead('含双清物流价格(¥)<br>(入仓审核后/审核前)', 'disposalNum', '200'),
      new LogisticsTableHead('国际物流<br>保单号', 'stockPrice', '100'),
      new LogisticsTableHead('物流发运状态', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('头程物流跟踪号<br>二程物流跟踪号', 'stockPrice', '200'),
      new LogisticsTableHead('预订/审核<br>起运/送达', 'getSavePriceByTable', '100'),
      new LogisticsTableHead('操作', 'getShowNumAndActualNumByTable', '150'),
    ]
    return arr
  }
  /**已支付物流单表头 */
  static NEWPAIDTABLEHEAD(){
    let arr = [
      new LogisticsTableHead('选择', 'check', '40'),
      new LogisticsTableHead('发货单号<br>(含发补货计划单数量)', 'img', '180'),
      new LogisticsTableHead('创建日期', 'img', '100'),
      new LogisticsTableHead('总箱数', 'img', '80'),
      new LogisticsTableHead('总重量<br>(kg)', 'getNetProfitOfGoodsByTable', '80'),
      new LogisticsTableHead('总体积<br>(M³)', 'img', '80'),
      new LogisticsTableHead('货物起运所在地', 'getNetProfitOfGoodsByTable', '120'),
      new LogisticsTableHead('发运目的国地址<br>(仓库代码)', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('头程物流方式<br>头程物流渠道', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('全程物流时效<br>(天数)', 'stockPrice', '200'),
      new LogisticsTableHead('是否包含<br>进口关税', 'getSavePriceByTable', '100'),
      new LogisticsTableHead('含双清物流价格(¥)<br>(入仓审核后/审核前)', 'disposalNum', '200'),
      new LogisticsTableHead('国际物流<br>保单号', 'stockPrice', '100'),
      new LogisticsTableHead('物流发运状态', 'getShowNumAndActualNumByTable', '150'),
      new LogisticsTableHead('头程物流跟踪号<br>二程物流跟踪号', 'stockPrice', '150'),
      new LogisticsTableHead('预订/审核<br>起运/送达', 'getSavePriceByTable', '100'),
      new LogisticsTableHead('货物<br>详细', 'disposalNum', '100'),
      new LogisticsTableHead('亚马逊仓<br>全部入仓确认', 'disposalNum', '150'),
    ]
    return arr
  }
  /**创建物流计划单进度条数据 */
  static NEWPLANPROGRESSARRAY(){
    let arr = [
      '点击物流计价 (注：生成发货单前需更新为当天物流价)',
      '点击右上角橙色"生成发货单"按钮',
      '在弹窗中勾选"FBA发补货计划单"',
      '点击"单独生成发货单"或"合并生成发货单"'
    ]
    return arr
  }
  /**创建物流单进度条数据 */
  static NEWORDERPROGRESSARRAY(){
    let arr = [
      '点击物流计价 (需更新为当天运费)',
      '点选"发货计划单"',
      '点击"生成发货单"',
      '点击"物流预订"',
      '等待来电确认',
      '收件人上门',
      '货物到达起运仓及检验',
      '支付物流费用',
      '国际物流起运及跟踪'
    ]
    return arr
  }
}

export {
  LogisticsNewMoodule, LogisticsSearchData
}
